
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { City } from '@/common/interface';
import moment from 'moment';

@Component
export default class LicenseInformationModuleField extends Vue {
  @Ref()
  childFormRef!: FormModel;

  moment = moment;

  formModel: any = {
    trafficInsuranceDate: '',
    commercialInsuranceDate: '',
    plateCityId: undefined,
  };

  commercialInsuranceDate = '';
  trafficInsuranceDate = '';

  @Prop({ default: [] })
  citys!: City[];

  @Prop({ default: [] })
  options!: Array<{ id: number; name: string; city: City[] }>;


  @Prop()
  disabled!: boolean;


  @Prop()
  readonly!: boolean;

  rules = {
    plateCityId: [{ required: true, message: '请输入车牌城市' }],
  };

  public async validateFields(): Promise<boolean> {
    try {
      const valid = await (this.childFormRef as any).validate();
      return valid;
    } catch (error) {
      // console.error('子表单校验失败:', error);
      return false;
    }
  }

  // onChange(value: any) {
  //   console.log(value);
  // }
  onChangeTraffic(value: any) {
    this.formModel.trafficInsuranceDate = moment(value).format('YYYY-MM-DD');
  }

  onChangeCommercial(value: any) {
    this.formModel.commercialInsuranceDate = moment(value).format('YYYY-MM-DD');
  }

  @Watch('formModel.plateCityId')
  watchPlateCityId() {
    this.watchFormModel();
  }

  watchFormModel() {
    this.$emit('update', this.formModel);
  }

  @Prop()
  value!: any;

  @Watch('value')
  handleValueChange() {
    this.formModel = this.value;
    this.formModel.plateCityId = this.formModel.plateCityId ? Number(this.formModel.plateCityId) : undefined;
  }

  mounted() {
    this.handleValueChange();
  }
}

